import { useState } from 'react'
import Select from '../Select'
import Input from '../Input'
import style from './style.module.scss'

interface Props {
  label?: string
  keyList: string[]
  onChange: (items: { key: string; value: string }[]) => void
}

export const KeyValueInput = ({ label, keyList = [], onChange }: Props) => {
  const [key, setKey] = useState<string>('')
  const [value, setValue] = useState<string>('')
  const [items, setItems] = useState<{ key: string; value: string }[]>([])

  const addItemHandler = () => {
    if (!key || !value) return

    const newItems = [...items, { key, value }]
    setItems(newItems)
    onChange(newItems)
    setKey('')
    setValue('')
  }

  const removeItemHandler = (index: number) => {
    const newItems = items.filter((_, i) => i !== index)
    setItems(newItems)
    onChange(newItems)
  }

  const filteredKeyList = () => {
    return keyList.filter((k) => !items.some((item) => item.key === k))
  }

  return (
    <div className={style.kv_input}>
      {label && <label className={style.label}>{label}</label>}
      <div className={style.input_wrap}>
        <Select value={key} className={style.key} list={filteredKeyList()} label="" onChange={(value: string) => setKey(value)} />
        <Input className={style.value} value={value} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setValue(e.target.value)} />
        <button type="button" title="Add item" onClick={addItemHandler}>
          +
        </button>
      </div>
      <div className={style.selected}>
        <div className={style.selected_title}>Selected {label}</div>
        <div className={style.selected_items}>
          {items.length > 0 &&
            items.map((item, i) => (
              <div key={i} className={style.item}>
                <span className={style.selected_key}>{item.key}</span>
                <span className={style.selected_value}>{item.value}</span>
                <button type="button" title="Remove item" onClick={() => removeItemHandler(i)}>
                  -
                </button>
              </div>
            ))}
            {items.length === 0 && <div className={style.selected_no_items}>No {label} selected</div>}
        </div>
      </div>
    </div>
  )
}
